import { useState } from "react";
import { DollarCircleTwoTone, DownloadOutlined, DownOutlined, FileImageOutlined, MoneyCollectOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { Alert, Avatar, Button, Card, Col, Divider, Form, Image, Input, List, message, Row, Select, Space, Tag, Upload } from "antd";
import Meta from "antd/es/card/Meta";
import constants from "../../constants";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { useForm } from "antd/es/form/Form";
import { useAuth } from "../../contexts/authContext";

const UploadDocument = ({ defaultList, updateRow, leadId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [formVisible, setFormVisible] = useState(false);
  const [form] = useForm();
  const { getToken } = useAuth();

  const { Option } = Select;

  const uploadDocument = async (formValues) => {
    const formData = new FormData();
    formData.append("document", formValues.documentUrl.file);
    formData.append("name", formValues.name);

    try {
      setLoading(true);
      const token = await getToken();
      const headers = {
        authorization: `bearer ${token}`,
      };
      const url = `${constants.NEW_DOMAIN}/api/v1/channelPartnerLeads/uploadDocument/${leadId}`;
      const res = await axios.post(url, formData, {
        headers,
      });

      const { name = "", documentUrl = "", status = "unverified" } = res.data?.data || {};

      updateRow(leadId, "documentRecords", [
        ...defaultList,
        {
          documentUrl,
          status,
          name,
        },
      ]);
      setFormVisible(false);
      form.resetFields();
      setLoading(false);
      message.success("Upload successfull , our team will review it shortly.");
    } catch (error) {
      setLoading(false);
      setError(error.message || "upload failed , try again later");
    }
  };

  return (
    <div>
      <Divider orientation="middle">Document Records</Divider>

      {defaultList?.length > 0 && (
        <List
          itemLayout="horizontal"
          dataSource={defaultList || []}
          renderItem={(item, index) => (
            <List.Item
              actions={[
                <Tag color={item.status === "verified" ? "green" : item.status === "unverified" ? "red" : "gold"}>{item.status}</Tag>,
                //   <a
                //     onClick={()=>{
                //         // remove the current file from fileList but how will i get the id?

                //     }}
                //   >
                //     Delete
                //   </a>,
              ]}
            >
              <List.Item.Meta
                title={
                  <a href={item.documentUrl} target="_blank" rel="noopener noreferrer">
                    Name : {item.name}
                  </a>
                }
                avatar={<Image src={item.documentUrl} preview width={"50px"} />}
                description={item.comments || "No comments from admin yet"}
              />
            </List.Item>
          )}
        />
      )}
      <Button
        type="link"
        onClick={() => {
          setFormVisible(!formVisible);
          form.resetFields();
        }}
      >
        {formVisible ? "Cancel" : " + Upload New Document"}
      </Button>
      {formVisible && (
        <Form layout="vertical" size="small" style={{ backgroundColor: "lightyellow", padding: "10px", margin: "10px" }} onFinish={uploadDocument}>
          <Form.Item name="name" label="Document Title" rules={[{ required: true }]}>
            <Select placeholder="Select which doc you're uploading">
              <Option value="passport-student">Student's Passport</Option>
              <Option value="passport-parent">Parent's Passport</Option>
              <Option value="birth-certificate">Birth Certificate</Option>
              <Option value="noc">NOC</Option>
              <Option value="pancard-parent">Parent's PAN CARD</Option>
              <Option value="passport-cover">Passport Cover</Option>
            </Select>
          </Form.Item>
          <Form.Item name="documentUrl" label="Document PDF" rules={[{ required: true }]}>
            <Upload
              listType="picture"
              accept=".pdf"
              beforeUpload={() => {
                return false;
              }}
            >
              <Button icon={<UploadOutlined />}>Upload</Button>
            </Upload>
          </Form.Item>
          {error && <Alert style={{ margin: "7px 0" }} message="Error" description={error} type="error" showIcon closable />}

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                Upload
              </Button>
            </Space>
          </Form.Item>
        </Form>
      )}
    </div>
  );
};
export default UploadDocument;
